import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '@/i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div ref={ref} className="relative" data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 text-xs rounded-full border border-[var(--border)] bg-white/80 backdrop-blur-sm px-3 py-1.5 text-[var(--text)] hover:bg-white transition-colors shadow-sm"
      >
        <Globe className="w-4 h-4 text-[var(--primary)]" />
        <span className="font-medium">{current.label}</span>
        <ChevronDown className={`w-3.5 h-3.5 text-[var(--muted)] transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute bottom-full mb-2 left-0 bg-white rounded-xl shadow-lg border border-[var(--border)] py-1.5 min-w-[160px] z-50">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => { i18n.changeLanguage(lang.code); setOpen(false); }}
              data-testid={`lang-${lang.code}`}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-[var(--surface)] transition-colors ${
                lang.code === i18n.language ? 'text-[var(--primary)] font-semibold bg-[var(--primary)]/5' : 'text-[var(--text)]'
              }`}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
